import { render, staticRenderFns } from "./ModalInquiryClosed.vue?vue&type=template&id=f1556bba&"
import script from "./ModalInquiryClosed.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryClosed.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryClosed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports